const EXTRA_LINE_VARIANT_ID = "gid://shopify/ProductVariant/51378631868706"; // replace with your variant
const STOREFRONT_API_TOKEN = "549ebf49a6024d2ac29e78a3707c0f4f"; // replace with your token
const EXTRA_LINE_NUMERIC_ID = "51378631868706"; // Numeric ID for cart operations

// Weight-based shipping variants
const SHIPPING_VARIANTS = {
  LIGHT: {
    variantId: "51378631868706",  // 0-10 KG
    graphqlId: "gid://shopify/ProductVariant/51378631868706",
    maxWeight: 10
  },
  MEDIUM: {
    variantId: "51378631901474", // 10-20 KG
    graphqlId: "gid://shopify/ProductVariant/51378631901474",
    maxWeight: 20
  },
  HEAVY: {
    variantId: "51378631934242",  // 20+ KG 
    graphqlId: "gid://shopify/ProductVariant/51378631934242",
    maxWeight: Infinity
  }
};

// Storage keys for tracking cart state
const CART_STATE_KEY = 'checkout_cart_state';
const EXTRA_ITEM_KEY = 'has_extra_checkout_item';



// Cart state management functions
function saveCartState() {
  try {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        localStorage.setItem(
          CART_STATE_KEY,
          JSON.stringify({ itemCount: cart.item_count, timestamp: Date.now() })
        );
      });
  } catch (error) {
    // Silent error handling
  }
}

function hasExtraCheckoutItem() {
  return localStorage.getItem(EXTRA_ITEM_KEY) === 'true';
}

function setExtraCheckoutItem(hasItem) {
  localStorage.setItem(EXTRA_ITEM_KEY, hasItem.toString());
}

// Weight calculation and shipping variant selection functions
async function calculateCartWeight() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    let totalWeight = 0;
    
    cart.items.forEach(item => {
      const isShippingVariant = Object.values(SHIPPING_VARIANTS).some(variant => 
        item.variant_id.toString() === variant.variantId
      );
      
      if (!isShippingVariant) {
        const itemWeight = item.grams || 0;
        const itemTotalWeight = (itemWeight * item.quantity) / 1000;
        totalWeight += itemTotalWeight;
      }
    });
    
    return totalWeight;
    
  } catch (error) {
    return 0;
  }
}

// Calculate cart total price excluding shipping variants
async function calculateCartTotal() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    let totalPrice = 0;
    
    cart.items.forEach(item => {
      const isShippingVariant = Object.values(SHIPPING_VARIANTS).some(variant => 
        item.variant_id.toString() === variant.variantId
      );
      
      if (!isShippingVariant) {
        const itemTotalPrice = item.final_price * item.quantity;
        totalPrice += itemTotalPrice;
      }
    });
    
    const totalAmount = totalPrice / 100;
    return totalAmount;
    
  } catch (error) {
    return 0;
  }
}

// Get estimated taxes from checkout page or calculate from cart
async function getEstimatedTaxes() {
  try {
    const allSpans = document.querySelectorAll('span');
    
    for (const span of allSpans) {
      const text = span.textContent || '';
      
      if (text.includes('CHF') || text.includes('EUR') || text.includes('USD') || text.includes('$') || text.includes('€')) {
        const parentRow = span.closest('[role="row"]');
        if (parentRow) {
          const headerText = parentRow.querySelector('[role="rowheader"]')?.textContent || '';
          
          if (headerText.toLowerCase().includes('estimated tax') || 
              headerText.toLowerCase().includes('tax') ||
              headerText.toLowerCase().includes('steuer')) {
            const cleanText = text
              .replace(/CHF\s*/, '')
              .replace(/[€$£¥]\s*/, '')
              .replace(/&nbsp;/g, '')
              .replace(/\u00A0/g, '')
              .replace(/[^\d.,]/g, '');
            
            if (cleanText) {
              const taxAmount = parseFloat(cleanText.replace(',', '.'));
              if (!isNaN(taxAmount) && taxAmount > 0) {
                // Check if this looks like cents (large number) or CHF (small number)
                // If it's > 100, it's likely in cents
                if (taxAmount > 100) {
                  return taxAmount / 100; // Convert cents to CHF
                }
                return taxAmount; // Already in CHF
              }
            }
          }
        }
      }
    }
    
    // Also check the cart.tax from the API
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    if (cart.total_tax && cart.total_tax > 0) {
      // cart.total_tax is in cents
      return cart.total_tax / 100; // Convert to CHF
    }
    
    return 0;
    
  } catch (error) {
    return 0;
  }
}

// Calculate total including cart items + estimated taxes
async function calculateTotalWithTaxes() {
  try {
    const cartTotal = await calculateCartTotal();
    const estimatedTaxes = await getEstimatedTaxes();
    const totalWithTaxes = cartTotal + estimatedTaxes;
    
    return totalWithTaxes;
    
  } catch (error) {
    return 0;
  }
}

function getShippingVariantForWeight(weightKg) {
  if (weightKg <= 10) {
    return SHIPPING_VARIANTS.LIGHT;
  } else if (weightKg <= 20) {
    return SHIPPING_VARIANTS.MEDIUM;
  } else {
    return SHIPPING_VARIANTS.HEAVY;
  }
}

// Function to check if any shipping variant is in cart
async function getExistingShippingVariant() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    for (const item of cart.items) {
      for (const [key, variant] of Object.entries(SHIPPING_VARIANTS)) {
        if (item.variant_id.toString() === variant.variantId) {
          return { key, variant, item };
        }
      }
    }
    
    return null;
  } catch (error) {
    return null;
  }
}

// Remove any existing shipping variants from cart
async function removeExistingShippingVariants() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    const shippingItemsToRemove = [];
    
    cart.items.forEach((item, index) => {
      const isShippingVariant = Object.values(SHIPPING_VARIANTS).some(variant => 
        item.variant_id.toString() === variant.variantId
      );
      
      if (isShippingVariant) {
        shippingItemsToRemove.push({
          lineNumber: index + 1,
          variantId: item.variant_id,
          itemKey: item.key || item.id,
          title: item.product_title
        });
      }
    });
    
    if (shippingItemsToRemove.length === 0) {
      clearExtraCheckoutItem();
      return true;
    }
    
    for (const itemToRemove of shippingItemsToRemove) {
      try {
        let removePayload;
        if (itemToRemove.itemKey) {
          removePayload = { id: itemToRemove.itemKey, quantity: 0 };
        } else {
          const freshCart = await fetch('/cart.js').then(r => r.json());
          const freshLineNumber = freshCart.items.findIndex(item => 
            item.variant_id.toString() === itemToRemove.variantId
          ) + 1;
          
          if (freshLineNumber > 0) {
            removePayload = { line: freshLineNumber, quantity: 0 };
          } else {
            continue;
          }
        }
        
        const removeResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(removePayload)
        });

        await new Promise(resolve => setTimeout(resolve, 150));
        
      } catch (itemError) {
        // Continue with other items
      }
    }
    
    clearExtraCheckoutItem();
    
    if (window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('cart:updated'));
    }

    if (window.Shopify && window.Shopify.onCartUpdate) {
      window.Shopify.onCartUpdate();
    }
    
    return true;
    
  } catch (error) {
    return false;
  }
}

function clearExtraCheckoutItem() {
  localStorage.removeItem(EXTRA_ITEM_KEY);
}

window.cleanupCheckoutCart = function () {
  if (hasExtraCheckoutItem()) {
    removeExistingShippingVariants();
  }
};
async function addShippingVariant(shippingVariant) {
  try {
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: shippingVariant.variantId, 
        quantity: 1 
      })
    });

    if (!addResponse.ok) {
      throw new Error(`Failed to add shipping variant: ${addResponse.status}`);
    }

    const addResult = await addResponse.json();
    
    setExtraCheckoutItem(true);
    window.dispatchEvent(new CustomEvent('cart:updated'));
    
    return true;
  } catch (error) {
    return false;
  }
}

// Function to check if any shipping variant is in cart
async function isExtraItemInCart() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const hasShippingVariant = cart.items.some(item =>
      Object.values(SHIPPING_VARIANTS).some(variant => 
        item.variant_id.toString() === variant.variantId
      )
    );

    return hasShippingVariant;
  } catch (error) {
    return false;
  }
}

async function removeExtraItemFromCart() {
  try {
    const removeResponse = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: EXTRA_LINE_NUMERIC_ID, 
        quantity: 0 
      })
    });

    if (!removeResponse.ok) {
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          updates: { 
            [EXTRA_LINE_NUMERIC_ID]: 0 
          } 
        })
      });
      
      if (!updateResponse.ok) {
        throw new Error(`Both removal methods failed`);
      }
      
      const result = await updateResponse.json();
    } else {
      const result = await removeResponse.json();
    }

    clearExtraCheckoutItem();

    if (window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('cart:updated'));
    }

    if (window.Shopify && window.Shopify.onCartUpdate) {
      window.Shopify.onCartUpdate();
    }

    return true;
  } catch (error) {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const extraItemLines = [];
      cart.items.forEach((item, index) => {
        if (
          item.variant_id.toString() === EXTRA_LINE_NUMERIC_ID ||
          item.id.toString() === EXTRA_LINE_NUMERIC_ID
        ) {
          extraItemLines.push(index + 1);
        }
      });

      if (extraItemLines.length === 0) {
        clearExtraCheckoutItem();
        return true;
      }

      for (const lineNumber of extraItemLines) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineNumber, quantity: 0 })
        });
      }

      clearExtraCheckoutItem();
      return true;
    } catch (fallbackError) {
      return false;
    }
  }
}

// Function to add extra item to cart (already using AJAX API - keep as is)
async function addExtraItemToCart() {
  try {
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: EXTRA_LINE_NUMERIC_ID, quantity: 1 })
    });

    if (!addResponse.ok) {
      throw new Error(`Failed to add item to cart: ${addResponse.status}`);
    }

    const addResult = await addResponse.json();

    setExtraCheckoutItem(true);

    if (window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('cart:updated'));
    }

    return true;
  } catch (error) {
    return false;
  }
}

async function addExtraItemToCartEnhanced() {
  try {
    const currentCart = await fetch('/cart.js').then(r => r.json());
    const existingExtraItems = currentCart.items.filter(item => 
      item.variant_id.toString() === EXTRA_LINE_NUMERIC_ID ||
      item.id.toString() === EXTRA_LINE_NUMERIC_ID
    );
    
    if (existingExtraItems.length > 0) {
      setExtraCheckoutItem(true);
      return true;
    }
    
    const payloads = [
      { id: EXTRA_LINE_NUMERIC_ID, quantity: 1 },
      { items: [{ id: parseInt(EXTRA_LINE_NUMERIC_ID), quantity: 1 }] }
    ];
    
    for (const payload of payloads) {
      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (addResponse.ok) {
          const addResult = await addResponse.json();
          
          await new Promise(resolve => setTimeout(resolve, 200));
          const updatedCart = await fetch('/cart.js').then(r => r.json());
          const addedExtraItems = updatedCart.items.filter(item => 
            item.variant_id.toString() === EXTRA_LINE_NUMERIC_ID ||
            item.id.toString() === EXTRA_LINE_NUMERIC_ID
          );
          
          if (addedExtraItems.length > 0) {
            if (addedExtraItems[0].quantity > 1) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                  id: addedExtraItems[0].key || addedExtraItems[0].variant_id, 
                  quantity: 1 
                })
              });
            }
            
            setExtraCheckoutItem(true);
            window.dispatchEvent(new CustomEvent('cart:updated'));
            return true;
          }
        }
      } catch (e) {
        // Try next method
      }
    }
    
    throw new Error('All add methods failed');
    
  } catch (error) {
    return false;
  }
}

// Update the checkout click handler to use weight-based shipping with price limit
let isProcessingCheckout = false; // Flag to prevent duplicate processing

async function onCheckoutClick(e) {
  e.preventDefault();

  if (isProcessingCheckout) {
    return;
  }

  try {
    isProcessingCheckout = true;
    
    const totalWithTaxes = await calculateTotalWithTaxes();
    
    if (totalWithTaxes >= 600) {
      const existingShipping = await getExistingShippingVariant();
      if (existingShipping) {
        await removeExistingShippingVariants();
      }
      
      clearExtraCheckoutItem();
      saveCartState();
      localStorage.setItem('entering_checkout', 'true');
      
      await new Promise(resolve => setTimeout(resolve, 300));
      window.location.href = '/checkout';
      return;
    }
    
    const totalWeight = await calculateCartWeight();
    const requiredShippingVariant = getShippingVariantForWeight(totalWeight);
    
    const existingShipping = await getExistingShippingVariant();
    
    if (existingShipping && existingShipping.variant.variantId === requiredShippingVariant.variantId) {
      setExtraCheckoutItem(true);
    } else {
      await removeExistingShippingVariants();
      
      const success = await addShippingVariant(requiredShippingVariant);
      
      if (!success) {
        throw new Error('Failed to add shipping variant to cart');
      }
    }

    saveCartState();
    localStorage.setItem('entering_checkout', 'true');

    await new Promise(resolve => setTimeout(resolve, 300));
    
    window.location.href = '/checkout';
  } catch (error) {
    alert('There was an error processing your checkout. Please try again or contact support.');
  } finally {
    setTimeout(() => {
      isProcessingCheckout = false;
    }, 1000);
  }
}

// Rest of your existing functions remain the same...
async function findVariantsByProduct(productHandle) {
  try {
    const query = `
      query($handle: String!) {
        productByHandle(handle: $handle) {
          id
          title
          variants(first: 10) {
            edges {
              node {
                id
                title
                availableForSale
                price { amount }
              }
            }
          }
        }
      }
    `;

    const result = await sf(query, { handle: productHandle });
    const product = result.data?.productByHandle;

    if (product) {
      return product.variants.edges.map(edge => edge.node);
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
}

window.findVariantsByProduct = findVariantsByProduct;
window.validateVariant = validateVariant;
window.getProductVariant = getProductVariant;
window.addExtraItemToCart = addExtraItemToCartEnhanced;
window.removeExtraItemFromCart = removeExtraItemFromCart;
window.sf = sf;


// Function to get first available variant from a product ID
async function getProductVariant(productId) {
  try {
    const query = `
      query($id: ID!) {
        node(id: $id) {
          ... on Product {
            id
            title
            variants(first: 1) {
              edges {
                node {
                  id
                  availableForSale
                }
              }
            }
          }
        }
      }
    `;

    const result = await sf(query, { id: `gid://shopify/Product/${productId}` });
    const product = result.data?.node;

    if (product?.variants?.edges?.length > 0) {
      const variant = product.variants.edges[0].node;
      return variant.availableForSale ? variant.id : null;
    }

    return null;
  } catch (error) {
    return null;
  }
}

async function validateVariant(variantId) {
  try {
    const query = `
      query($id: ID!) {
        node(id: $id) {
          ... on ProductVariant {
            id
            title
            availableForSale
            product { title }
          }
        }
      }
    `;

    const result = await sf(query, { id: variantId });
    const variant = result.data?.node;

    if (!variant) {
      return false;
    }

    return variant.availableForSale;
  } catch (error) {
    return false;
  }
}

async function sf(query, variables) {
  try {
    const res = await fetch("/api/2024-01/graphql.json", {  // ← Changed to relative path
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_API_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    if (data.errors) {
      throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
    }

    return data;
  } catch (error) {
    throw error;
  }
}

// Get storefront cart ID
function getExistingCartId() {
  try {
    let token = window?.Shopify?.cart?.token;

    if (!token) {
      const metaTag = document.querySelector('meta[name="shopify-cart-token"]');
      if (metaTag) {
        token = metaTag.getAttribute('content');
      }
    }

    if (!token) {
      token = window.cart_token;
    }

    const cartId = token ? `gid://shopify/Cart/${token}` : null;

    return cartId;
  } catch (error) {
    return null;
  }
}

async function createCart() {
  try {
    const q = `
      mutation {
        cartCreate {
          cart { id checkoutUrl }
          userErrors { field message }
        }
      }
    `;

    const r = await sf(q, {});

    if (r.data.cartCreate.userErrors?.length > 0) {
      throw new Error(
        `Cart creation errors: ${JSON.stringify(
          r.data.cartCreate.userErrors
        )}`
      );
    }

    return r.data.cartCreate.cart;
  } catch (error) {
    throw error;
  }
}

async function addLines(cartId, lines) {
  try {
    const q = `
      mutation($cartId:ID!, $lines:[CartLineInput!]!) {
        cartLinesAdd(cartId:$cartId, lines:$lines) {
          cart { checkoutUrl }
          userErrors { field message }
        }
      }
    `;

    const result = await sf(q, { cartId, lines });

    if (result.data?.cartLinesAdd?.userErrors?.length > 0) {
      const errors = result.data.cartLinesAdd.userErrors;
      throw new Error(`Add lines errors: ${JSON.stringify(errors)}`);
    }

    return result;
  } catch (error) {
    throw error;
  }
}

// Enhanced page navigation handling
function handlePageNavigation() {
  const currentURL = window.location.href;
  const isCheckoutPage = currentURL.includes('/checkout') || currentURL.includes('/checkouts');
  const wasEnteringCheckout = localStorage.getItem('entering_checkout') === 'true';
  
  console.log('Navigation detected:', { 
    currentURL, 
    isCheckoutPage, 
    wasEnteringCheckout,
    hasExtraItem: hasExtraCheckoutItem()
  });

  if (isCheckoutPage) {
    localStorage.removeItem('entering_checkout');
    localStorage.removeItem('last_non_checkout_url');
  } else {
    // We're NOT on checkout page
    
    // Store current non-checkout URL for future reference
    if (!currentURL.includes('/cart')) {
      localStorage.setItem('last_non_checkout_url', currentURL);
    }
    
    // If we were just entering checkout but now we're on cart page, clean up
    if (hasExtraCheckoutItem() && (wasEnteringCheckout || currentURL.includes('/cart'))) {
      console.log('Cleaning up shipping variant on cart page');
      
      // Force immediate removal
      removeExistingShippingVariants().then(() => {
        // Force a page refresh to ensure clean state
        const isCartPage = currentURL.includes('/cart');
        const referrer = document.referrer;
        const cameFromCheckout = referrer && (referrer.includes('/checkout') || referrer.includes('/checkouts'));
        
        if (isCartPage && cameFromCheckout) {
          console.log('Refreshing cart page after cleanup');
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      });
    }
    
    localStorage.removeItem('entering_checkout');
  }
}


// Detect navigation
let navigationState = {
  lastPage: null,
  isNavigatingBack: false,
  lastCheckoutNavigation: null
};

// Enhanced popstate handler
function handlePopState(event) {
  const currentURL = window.location.href;
  const wasCheckout = navigationState.lastPage && 
    (navigationState.lastPage.includes('/checkout') || 
     navigationState.lastPage.includes('/checkouts'));
  
  if (wasCheckout && hasExtraCheckoutItem()) {
    console.log('Back navigation from checkout detected');
    navigationState.isNavigatingBack = true;
    
    // Immediate cleanup
    removeExistingShippingVariants().then(() => {
      setTimeout(() => {
        if (currentURL.includes('/cart')) {
          window.location.reload();
        }
      }, 300);
    });
  }
  
  navigationState.lastPage = currentURL;
  setTimeout(handlePageNavigation, 100);
}

// Track all navigation
function trackNavigation() {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;
  
  history.pushState = function(...args) {
    navigationState.lastPage = window.location.href;
    return originalPushState.apply(this, args);
  };
  
  history.replaceState = function(...args) {
    navigationState.lastPage = window.location.href;
    return originalReplaceState.apply(this, args);
  };
  
  // Initial state
  navigationState.lastPage = window.location.href;
}

// Better cart page detection
function isCartPage() {
  const currentURL = window.location.href;
  const pathname = window.location.pathname;
  
  return (
    currentURL.includes('/cart') ||
    pathname === '/cart' ||
    pathname.includes('/cart?') ||
    document.querySelector('.cart, [data-cart], .cart__contents') ||
    document.querySelector('form[action*="/cart"]') ||
    document.querySelector('[data-section-type="cart"]')
  );
}

function handleVisibilityChange() {
  if (!document.hidden) {
    setTimeout(handlePageNavigation, 100);
  }
}

function handleHashChange() {
  setTimeout(handlePageNavigation, 100);
}

let lastUrl = location.href;
function detectUrlChange() {
  const currentUrl = location.href;
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl;
    setTimeout(handlePageNavigation, 100);
  }
}

// Initialize page state
function initializePageStateManagement() {
  console.log('Initializing page state management...');
  
  trackNavigation();
  
  const currentURL = window.location.href;
  const isCheckoutPage = currentURL.includes('/checkout') || currentURL.includes('/checkouts');
  
  // Clean localStorage on initial load
  if (!isCheckoutPage) {
    const hasExtraItem = hasExtraCheckoutItem();
    const cartPage = isCartPage();
    
    if (hasExtraItem && cartPage) {
      console.log('Initial load on cart page with extra item - cleaning up');
      
      removeExistingShippingVariants().then(() => {
        // Check if we still have the extra item after removal
        setTimeout(async () => {
          const stillHasItem = await isExtraItemInCart();
          if (stillHasItem) {
            console.log('Extra item still in cart after removal - forcing refresh');
            window.location.reload();
          }
        }, 1000);
      });
    }
  }
  
  // Handle navigation from checkout
  const referrer = document.referrer;
  const cameFromCheckout = referrer && (referrer.includes('/checkout') || referrer.includes('/checkouts'));
  
  if (cameFromCheckout && isCartPage()) {
    console.log('Navigated to cart from checkout - cleaning up');
    
    removeExistingShippingVariants().then(() => {
      setTimeout(() => {
        window.location.reload();
      }, 800);
    });
  }
  
  // Set up event listeners
  window.addEventListener('popstate', handlePopState);
  window.addEventListener('hashchange', handleHashChange);
  document.addEventListener('visibilitychange', handleVisibilityChange);
  
  // Enhanced beforeunload handler
  window.addEventListener('beforeunload', () => {
    const currentURL = window.location.href;
    const isLeavingCheckout = currentURL.includes('/checkout') || currentURL.includes('/checkouts');
    
    if (isLeavingCheckout) {
      // Set a flag that will trigger cleanup on next load
      localStorage.setItem('should_clean_on_load', 'true');
      localStorage.setItem('checkout_exit_time', Date.now().toString());
    }
  });
  
  // Check for cleanup flags on page load
  setTimeout(() => {
    const shouldClean = localStorage.getItem('should_clean_on_load') === 'true';
    const exitTime = parseInt(localStorage.getItem('checkout_exit_time') || '0');
    const timeSinceExit = Date.now() - exitTime;
    
    if (shouldClean && timeSinceExit < 5000) { // Within 5 seconds
      console.log('Cleaning up after checkout exit');
      
      if (isCartPage()) {
        removeExistingShippingVariants().then(() => {
          localStorage.removeItem('should_clean_on_load');
          localStorage.removeItem('checkout_exit_time');
          window.location.reload();
        });
      } else {
        localStorage.removeItem('should_clean_on_load');
        localStorage.removeItem('checkout_exit_time');
      }
    }
  }, 100);
}

// Force refresh with cleanup
async function forceCartRefresh() {
  const currentURL = window.location.href;
  const isCart = currentURL.includes('/cart');
  
  if (isCart && hasExtraCheckoutItem()) {
    console.log('Force refreshing cart page');
    
    // First, try to remove the item
    const success = await removeExistingShippingVariants();
    
    if (success) {
      // Wait a bit then reload
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else {
      // If removal failed, still reload to try again
      window.location.reload();
    }
  }
}

// Call this periodically on cart pages
function startCartPageMonitor() {
  if (isCartPage()) {
    console.log('Starting cart page monitor');
    
    // Check immediately
    setTimeout(() => {
      if (hasExtraCheckoutItem()) {
        forceCartRefresh();
      }
    }, 1000);
    
    // Check periodically
    const monitorInterval = setInterval(() => {
      if (!isCartPage()) {
        clearInterval(monitorInterval);
        return;
      }
      
      if (hasExtraCheckoutItem()) {
        forceCartRefresh();
      }
    }, 3000);
  }
}



// NEW: Buy Now button handler (for direct-to-checkout flows)
let isProcessingBuyNow = false;
let skipFetchInterceptor = false; // Flag to prevent fetch interceptor from double-processing

async function onBuyNowClick(e, originalHandler) {
  if (isProcessingBuyNow) {
    return;
  }

  try {
    isProcessingBuyNow = true;
    skipFetchInterceptor = true;
    
    const form = e.target.closest('form') || e.target.closest('product-form')?.querySelector('form');
    if (!form) {
      return originalHandler?.();
    }
    
    const variantId = form.querySelector('[name="id"]')?.value;
    const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1');
    
    if (!variantId) {
      return originalHandler?.();
    }
    
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });

    if (!addResponse.ok) {
      throw new Error(`Failed to add product to cart: ${addResponse.status}`);
    }

    await new Promise(resolve => setTimeout(resolve, 300));
    
    const totalWithTaxes = await calculateTotalWithTaxes();
    
    if (totalWithTaxes >= 600) {
      const existingShipping = await getExistingShippingVariant();
      if (existingShipping) {
        await removeExistingShippingVariants();
      }
      
      clearExtraCheckoutItem();
    } else {
      const totalWeight = await calculateCartWeight();
      const requiredShippingVariant = getShippingVariantForWeight(totalWeight);
      
      const existingShipping = await getExistingShippingVariant();
      
      if (existingShipping && existingShipping.variant.variantId === requiredShippingVariant.variantId) {
        setExtraCheckoutItem(true);
      } else {
        await removeExistingShippingVariants();
        
        const doubleCheck = await getExistingShippingVariant();
        if (!doubleCheck) {
          await addShippingVariant(requiredShippingVariant);
        } else {
          setExtraCheckoutItem(true);
        }
      }
    }
    
    saveCartState();
    localStorage.setItem('entering_checkout', 'true');
    
    await new Promise(resolve => setTimeout(resolve, 300));
    
    window.location.href = '/checkout';
    
  } catch (error) {
    if (originalHandler) {
      originalHandler();
    } else {
      alert('There was an error processing your purchase. Please try again or contact support.');
    }
  } finally {
    setTimeout(() => {
      isProcessingBuyNow = false;
      skipFetchInterceptor = false;
    }, 1000);
  }
}



// Periodic cleanup
function startPeriodicCleanup() {
  setInterval(async () => {
    const currentURL = window.location.href;
    const isCheckoutPage =
      currentURL.includes('/checkout') || currentURL.includes('/checkouts');

    if (!isCheckoutPage && hasExtraCheckoutItem()) {
      const actuallyInCart = await isExtraItemInCart();

      if (actuallyInCart) {
        await removeExtraItemFromCart();
      } else {
        clearExtraCheckoutItem();
      }
    }
  }, 10000);
}

// Attach handler with better event delegation
let globalHandlerAttached = false;

function attachCheckoutHandlers() {
  if (!globalHandlerAttached) {
    document.addEventListener('click', globalCheckoutHandler);
    globalHandlerAttached = true;
  }
}

function globalCheckoutHandler(e) {
  const target = e.target;
  
  const isCheckoutButton = (
    target.name === 'checkout' ||
    target.classList.contains('cart__checkout') ||
    target.href && target.href.includes('/checkout') ||
    target.closest('[name="checkout"]') ||
    target.closest('.cart__checkout') ||
    target.closest('a[href*="/checkout"]')
  );
  
  if (isCheckoutButton) {
    e.stopPropagation();
    onCheckoutClick(e);
  }
}

function interceptProductFormSubmissions() {
  console.log('Setting up product form submission interception...');
  
  // Keep track of whether we're on a cart page
  const isCartPage = window.location.pathname.includes('/cart') || 
                     document.querySelector('.cart-page, .cart__contents');
  
  // Method 1: Intercept via fetch API for cart/add requests
  if (!window.cartAddInterceptorAttached) {
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      
      // Only intercept cart/add.js requests from product pages (not cart pages)
      if (typeof url === 'string' && url.includes('/cart/add') && !isCartPage) {
        console.log('Intercepting cart/add request from product form');
        
        const result = originalFetch.apply(this, args);
        
        // Apply shipping logic after successful add (only if not processing buy now)
        result.then(async (response) => {
          if (response.ok && !skipFetchInterceptor) {
            console.log('Product added to cart successfully, applying shipping logic...');
            
            // Small delay to ensure cart is updated
            setTimeout(async () => {
              try {
                const totalWithTaxes = await calculateTotalWithTaxes();
                
                if (totalWithTaxes >= 600) {
                  console.log('Free shipping threshold reached after product add');
                  const existingShipping = await getExistingShippingVariant();
                  if (existingShipping) {
                    await removeExistingShippingVariants();
                  }
                  clearExtraCheckoutItem();
                } else {
                  console.log('Applying weight-based shipping after product add');
                  const totalWeight = await calculateCartWeight();
                  const requiredShippingVariant = getShippingVariantForWeight(totalWeight);
                  
                  const existingShipping = await getExistingShippingVariant();
                  
                  if (!existingShipping || existingShipping.variant.variantId !== requiredShippingVariant.variantId) {
                    await removeExistingShippingVariants();
                    await addShippingVariant(requiredShippingVariant);
                  }
                }
              } catch (error) {
                console.error('Error applying shipping logic after product add:', error);
              }
            }, 500);
          } else if (skipFetchInterceptor) {
            console.log('Skipping fetch interceptor - buy now handler will manage shipping logic');
          }
        }).catch(() => {
          // Handle fetch errors silently
        });
        
        return result;
      }
      
      // For cart quantity updates, don't apply shipping logic immediately
      if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update'))) {
        // Just return the original fetch without intercepting shipping logic
        console.log('Cart quantity change detected - skipping shipping logic');
        return originalFetch.apply(this, args);
      }
      
      return originalFetch.apply(this, args);
    };
    window.cartAddInterceptorAttached = true;
    console.log('Cart add interceptor attached');
  }
}

// NEW: Enhanced buy now button interception
function interceptBuyNowButtons() {
  document.addEventListener('click', function(e) {
    const target = e.target;
    
    const isBuyNowButton = (
      target.classList.contains('shopify-payment-button__button') ||
      target.classList.contains('shopify-payment-button__more-options') ||
      target.closest('.shopify-payment-button') ||
      target.closest('.dynamic-checkout') ||
      (target.textContent && target.textContent.toLowerCase().includes('buy now')) ||
      (target.textContent && target.textContent.toLowerCase().includes('buy it now')) ||
      target.closest('[data-testid="Checkout-button"]') ||
      target.closest('.payment-button')
    );
    
    if (isBuyNowButton) {
      e.preventDefault();
      e.stopPropagation();
      
      const originalHandler = () => {
        e.target.removeEventListener('click', arguments.callee);
        setTimeout(() => {
          const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          e.target.dispatchEvent(event);
        }, 100);
      };
      
      onBuyNowClick(e, originalHandler);
    }
  }, true);
}

// NEW: Enhance product forms with custom submit handlers
function enhanceProductForms() {
  const productForms = document.querySelectorAll('product-form, form[data-type="add-to-cart-form"]');
  
  productForms.forEach((formElement, index) => {
    if (formElement.dataset.shippingEnhanced) {
      return;
    }
    
    formElement.dataset.shippingEnhanced = 'true';
    
    const form = formElement.tagName === 'FORM' ? formElement : formElement.querySelector('form');
    if (!form) return;
    
    form.addEventListener('submit', async function(e) {
      const isDirectCheckout = e.submitter && (
        e.submitter.textContent.toLowerCase().includes('buy now') ||
        e.submitter.classList.contains('shopify-payment-button__button') ||
        e.submitter.closest('.shopify-payment-button')
      );
      
      if (isDirectCheckout) {
        e.preventDefault();
        e.stopPropagation();
        
        onBuyNowClick(e, null);
      }
    }, true);
  });
}

let lastButtonCount = 0;

function attachDirectCheckoutHandlers() {
  const buttons = document.querySelectorAll(
    '[name="checkout"], .cart__checkout, a[href*="/checkout"], .btn--checkout, [data-checkout], .checkout-button'
  );

  if (buttons.length === lastButtonCount) {
    return;
  }

  buttons.forEach(btn => {
    if (btn.dataset.checkoutHandlerAttached) {
      return;
    }
    
    btn.dataset.checkoutHandlerAttached = 'true';
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      onCheckoutClick(e);
    });
  });
  
  lastButtonCount = buttons.length;
}

// Listen for cart updates to re-attach handlers
function listenForCartUpdates() {
  document.addEventListener('cart:updated', () => {
    setTimeout(attachDirectCheckoutHandlers, 200);
  });

  if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
    const originalOnCartUpdate = window.Shopify.onCartUpdate;
    window.Shopify.onCartUpdate = function(...args) {
      originalOnCartUpdate.apply(this, args);
      setTimeout(attachDirectCheckoutHandlers, 200);
    };
  }

  if (!window.fetchInterceptorAttached) {
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      const result = originalFetch.apply(this, args);
      
      if (typeof url === 'string' && (
        url.includes('/cart/add') || 
        url.includes('/cart/change') || 
        url.includes('/cart/update')
      )) {
        result.then(() => {
          setTimeout(attachDirectCheckoutHandlers, 300);
        });
      }
      
      return result;
    };
    window.fetchInterceptorAttached = true;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  console.log('DOM loaded - initializing shipping logic');
  
  attachCheckoutHandlers();
  attachDirectCheckoutHandlers();
  
  interceptProductFormSubmissions();
  interceptBuyNowButtons();
  enhanceProductForms();
  
  listenForCartUpdates();
  
  initializePageStateManagement();
  startPeriodicCleanup();
  startCartPageMonitor();
  
  // Initial navigation check
  setTimeout(() => {
    handlePageNavigation();
  }, 500);
  
  // Periodic handler re-attachment
  setInterval(() => {
    attachDirectCheckoutHandlers();
    enhanceProductForms();
  }, 3000);
});

function hideKostenlosText() {
  // Target strong tags with those specific classes
  document.querySelectorAll('strong._19gi7yt0._19gi7yt8').forEach(el => {
    if (el.textContent.includes('Kostenlos')) {
      el.style.display = 'none';
    }
  });
}